import { cn } from "../../../lib/utils.js";
import {
  INBOX_ATTACHMENT_IMAGE_SHELL_CLASS,
} from "../inbox-image-frame.js";
import type { InboxImageLayout } from "./MessageMediaImage.js";

export function MessageMediaImageSkeleton({
  className,
  label,
  overlay = false,
  layout = "default",
}: {
  className?: string;
  label?: string;
  overlay?: boolean;
  layout?: InboxImageLayout;
}): React.JSX.Element {
  const isBubble = layout === "bubble";
  const shellClass = cn(
    INBOX_ATTACHMENT_IMAGE_SHELL_CLASS,
    isBubble ? "rounded-[inherit]" : "rounded-md",
    !isBubble && !overlay && "my-1",
    className,
  );

  if (overlay) {
    return (
      <div
        className={cn("absolute inset-0 animate-pulse bg-surface-muted", className)}
        role="status"
        aria-busy="true"
        aria-label={label}
      >
        <div
          className="absolute inset-0 bg-gradient-to-br from-surface-muted via-surface-elevated/40 to-surface-muted"
          aria-hidden="true"
        />
      </div>
    );
  }

  return (
    <div
      className={shellClass}
      role="status"
      aria-busy="true"
      aria-label={label}
    >
      <div className="absolute inset-0 animate-pulse bg-surface-muted" />
      <div
        className="absolute inset-0 bg-gradient-to-br from-surface-muted via-surface-elevated/40 to-surface-muted"
        aria-hidden="true"
      />
    </div>
  );
}
